import BaseRadio from '@material-ui/core/Radio'

const Radio = BaseRadio

export default Radio
